import { singleValueReducer } from 'store/reducerUtils';
import { SET_DEAL_FILTER } from 'modules/settings/submodules/clients/deals/components/Filter/store/actions';

export const dealFilter = singleValueReducer(SET_DEAL_FILTER, '');
